<template>
    <div class="obs-modal-container">
        <div class="modal-form-container">
            <div class="title-box">
                <h2>{{ getString('alguma_observacao') }}</h2>
            </div>

            <div class="product-info-wrapper">
                <div class="image-container">
                    <img v-if="obsModalProd.subItemProductImages && obsModalProd.subItemProductImages.large != null"
                        :src="getImagesURL(obsModalProd, 'subItemProductImages', 'large')" alt="">
                    <img v-else :src="noImageSrc">
                </div>

                <div class="name-container" v-if="obsModalProd.subItemName">
                    <h2 v-text="getProductLanguage(obsModalProd, 'subItemName')"></h2>
                </div>
            </div>

            <div class="details-container" v-if="obsModalProd.subItemDescription">
                <p v-text="'Descrição: ' + getProductLanguage(obsModalProd, 'subItemDescription')"></p>
            </div>

            <div class="observations-container" id="observations-container">
                <div class="observations-group-container"
                    v-for="(obsGroup, key) in obsModalProd.subItemObservationsChoice" :key="key">
                    <span class="grupo-op-name">
                        <span v-text="getProductLanguage(obsGroup, 'subItemObsGroupName')"></span>
                        <span
                            v-text="`${selectedObs.length || 0} / ${obsModalProd.subItemObservationsChoice[key].maxQuantity || (obsGroup.subItemObservations || []).length}`"></span>
                    </span>
                    <div class="min-observations-message" v-if="obsGroup.minQuantity > 0" :class="{'red-text': selectedObs.length < obsGroup.minQuantity}">{{ getMessageObservationsMinQuantity(obsGroup.minQuantity) }}</div>
                    <div class="obs-item-container">
                        <div class="item-obs" v-for="(obs, key2) in removeBlockedProdsObs(obsGroup.subItemObservations)"
                            :key="key2" :class="{'selected': obsIsSelected(obs)}">
                            <div class="container-input">
                                <input class="styled-input" :id="'child-item-obs' + key2 + obs.subItemObsCode"
                                    type="checkbox" :value="obs" v-model="selectedObs"
                                    @change="validateObs(obs, $event)">
                                <span class="checkmark"></span>
                            </div>
                            <label style="display: block; margin: auto 0;"
                                :for="'child-item-obs' + key2 + obs.subItemObsCode">
                                <span v-text="getProductLanguage(obs, 'subItemObsName')"></span>
                                <span class="obs-price" v-if="obs.price" v-text="` + ${formatMoney(obs.price)}`"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div id="keyboard-filler" v-if="editingObs"></div>
            </div>
        </div>

        <div v-if="checkMinObs()" class="prod-item-footer">
            <DefaultButton :text="getString('sem_observacao')" outlined="true" @defaultBtnClick="modalCancel"></DefaultButton>
            <DefaultButton :text="getString('confirmar')" @defaultBtnClick="modalConfirm"></DefaultButton>
        </div>
        <div v-else class="prod-item-footer" style="display: flex">
            <DefaultButton :text="getString('confirmar')" @defaultBtnClick="modalConfirm" :disabled="minObs"></DefaultButton>
        </div>

        <div class="keyboard-overlay" v-if="editingObs" @click="closeKeyboard"></div>
        <AndroidKeyboard id="android-keyboard" v-if="editingObs" :inputElement="inputElement" :layout="layout">
        </AndroidKeyboard>
        <!-- <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input" /> -->
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
import LocaleController from '@/assets/controllers/LocaleController'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import ClarityController from '@/assets/controllers/ClarityController'

export default {
    name: 'ObservationsModal',
    components: {
        DefaultButton,
        AndroidKeyboard
    },
    data () {
        return {
            inputElement: null,
            layout: keyboardLayout.TEXT,
            editingObs: false,
            selectedObs: [],
            noImageSrc: null,
            exibeObsDigitada: Util.getLocalConfigs('permiteObsDigitada'),
            typedObs: '',
            junk: require('../../static/icons/junk-icon.png'),
            minObs: true
        }
    },
    props: ['obsModalProd'],
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
        this.obsModalProd.subItemObservationsChoice && this.obsModalProd.subItemObservationsChoice.forEach(obsGroup => {
            (obsGroup.subItemObservations || []).forEach(obs => {
                obs.subItemObsGroupCode = obsGroup.subItemObsGroupCode
            })
        })
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target

                if (!this.visible) {
                    this.visible = true
                }

                let obsContainer = document.getElementById('observations-container')
                setTimeout(() => {
                    obsContainer.scrollTo(0, obsContainer.scrollHeight)
                }, 100)
            }
        },
        hide: function () {
            this.visible = false
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
            // return Util.getLocalConfigs('urlIMGOdhenInterface')
        },
        modalCancel: function () {
            this.$emit('obsModalClose', this.obsModalProd)
        },
        modalConfirm: function () {
            this.obsModalProd.observations = this.selectedObs
            this.obsModalProd.typedObs = this.typedObs.trim()

            this.$emit('obsModalClose', this.obsModalProd)
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        validateObs: function (obs, clickEvent) {
            let obsGroup = this.obsModalProd.subItemObservationsChoice.find(element => element.subItemObsGroupCode === obs.subItemObsGroupCode)

            let maxObservations = obsGroup.maxQuantity || 0
            let minObservations = obsGroup.minQuantity || 0

            let groupSelectedObs = []

            if (this.selectedObs && this.selectedObs.length) {
                groupSelectedObs = this.selectedObs.filter(element => element.subItemObsGroupCode === obs.subItemObsGroupCode)
            }

            let groupObsNumber = (groupSelectedObs && groupSelectedObs.length) || 0
            let checkObsMax = ((maxObservations != null && maxObservations !== 0) && groupObsNumber > maxObservations && clickEvent.srcElement.checked)
            let checkObsMin = (minObservations === 0) || ((minObservations != null && minObservations !== 0) && groupObsNumber >= minObservations)
            if (checkObsMax) {
                this.selectedObs.pop()
                clickEvent.srcElement.checked = false
            }
            this.minObs = !checkObsMin
            if (clickEvent.srcElement.checked) {
                ClarityController.event('usuario_selecionou_observacao')
                ClarityController.setTag('observacao_selecionada', obs.subItemObsName)
            } else {
                ClarityController.event('usuario_removeu_observacao')
                ClarityController.setTag('observacao_deselecionada', obs.subItemObsName)
            }
            this.$forceUpdate()
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        editObs: function () {
            this.inputElement = this.$refs.typedObsModalDiv
            this.editingObs = true

            let obsContainer = document.getElementById('observations-container')
            setTimeout(() => {
                obsContainer.scrollTo(0, obsContainer.scrollHeight)
            }, 100)
        },
        closeKeyboard: function () {
            this.editingObs = false
            this.typedObs = this.$refs.typedObsModalDiv.innerText
        },
        removeBlockedProdsObs: function (obs) {
            return Util.removeBlockedProdsObs(obs)
        },
        obsIsSelected: function (obs) {
            if (!this.selectedObs || this.selectedObs.length === 0) {
                return false
            }
            return this.selectedObs.find(element => element.subItemObsCode === obs.subItemObsCode && element.subItemObsGroupCode === obs.subItemObsGroupCode && element.subItemObsName === obs.subItemObsName && element.price === obs.price)
        },
        getMessageObservationsMinQuantity: function (minQuantity) {
            return this.getString('escolha_pelo_menos') + ' ' + minQuantity + ' ' + (minQuantity > 1 ? this.getString('observacoes') : this.getString('observacao')) + ' *'
        },
        checkMinObs: function () {
            let minObsGroup = true
            this.obsModalProd.subItemObservationsChoice.forEach(obsGroup => {
                if (obsGroup.minQuantity && obsGroup.minQuantity > 0) {
                    minObsGroup = false
                }
            })
            return minObsGroup
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.obs-modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto 75px;
    background: @white;
    border-radius: 25px;
    z-index: 2;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    height: 1500px;
    display: grid;
    grid-template-rows: 1fr 180px;

    .modal-form-container {
        position: relative;
        overflow: hidden auto;
        display: flex;
        flex-direction: column;

        .title-box {
            background-color: @primary-color;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 25px 25px 0px 0px;
            margin-bottom: 15px;

            h2 {
                color: @white;
                margin: auto;
            }
        }

        .image-container {
            padding: 20px;

            img {
                height: 350px;
                object-fit: scale-down;
                margin: auto;
                display: block;
            }
        }

        .name-container {
            margin: 20px 0;
            display: block;
            /* margin-bottom: 50px;
            margin-left: 20px;
            margin-right: 20px; */
            color: @primary-color;
            text-align: center;
        }

        .details-container {
            padding: 15px 30px 15px 30px;
            display: flex;
            align-content: center;
            align-items: center;

            p {
                padding: 0;
            }
        }

        .observations-container {
            overflow: hidden scroll;
            position: relative;
            flex-grow: 1;
            padding: 0 30px 0 30px;
            height: calc(100% - 730px);
            width: calc(100% - 60px);

            .observations-group-container {
                margin-bottom: 25px;

                .grupo-op-name {
                    position: relative;
                    display: block;
                    padding: 10px 15px;
                    color: white;
                    background: @primary-color;
                    margin-bottom: 15px;

                    span {
                        display: inline-block;
                        vertical-align: middle;
                        font-weight: bold;
                        font-size: 2.5rem;
                    }
                }
                .min-observations-message {
                    font-size: 23px;
                    margin: 10px 0;
                    &.red-text {
                        color: red;
                    }
                }
                .obs-item-container {
                    position: relative;
                    display: grid;
                    grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
                    grid-column-gap: 15px;

                    .item-obs {
                        // display: grid;
                        margin-top: 15px;
                        // grid-column-gap: 15px;
                        // grid-template-columns: 15% calc(85% - 15px);
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        // border: 1px solid @primary-color;
                        border-radius: 5px;
                        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
                        padding: 15px 15px;
                        .container-input {
                            display: none;
                        }
                        &.quantity-control {
                            grid-template-columns: 40% calc(60% - 15px);
                        }

                        .obs-price {
                            color: var(--price-font-color);
                        }
                        &.selected {
                            box-shadow: 0 0 10px 0 rgba(19, 165, 0, 0.3);
                            background-color: @primary-color;
                            color: white;
                            .obs-price {
                                color: white;
                            }
                        }
                        label {
                            width: 100%;
                        }
                    }
                }

                .typed-obs-text {
                    font-size: 32px;
                    font-family: @default-font;
                    width: 100%;
                    resize: none;
                    border: 2px solid @primary-color;
                }

                .div-input-android {
                    position: relative;
                    display: block;
                    font-size: 32px;
                    height: 180px;
                    background-color: white;
                    color: black;
                    border: 2px solid @primary-color;
                    padding: 20px;
                }
            }

            #keyboard-filler {
                height: 170px;
            }
        }
    }

    .prod-item-footer {
        position: relative;
        display: grid;
        grid-template-columns: auto auto;
        background: rgba(0, 0, 0, 0.1);
        height: 180px;
        border-radius: 0px 0px 25px 25px;

        button {
            position: relative;
            display: block;
            margin: auto;
        }
    }
}

#keyboard {
    .keyboard;
    position: fixed;
    bottom: 0;
}

#android-keyboard {
    .keyboard;
    bottom: 60px;
    margin: auto;
}

.keyboard-overlay {
    z-index: 10;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
}

@media (max-width: 698px) {

    // Gertec SK210
    .obs-modal-container {
        margin: auto 25px;
        height: 600px;
        grid-template-rows: 1fr 60px;
        border-radius: 10px;

        .modal-form-container {
            .title-box {
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                height: 50px;
                margin-bottom: 0;

                h2 {
                    font-size: 27px;
                }
            }

            .image-container {
                padding: 10px;

                img {
                    height: 100px;
                }
            }

            .name-container {
                margin-bottom: 10px;
                h2 {
                    font-size: 20px;
                }
            }

            .observations-container {
                padding: 0 15px 0 15px;
                width: calc(100% - 30px);

                .observations-group-container {
                    margin-bottom: 15px;

                    .grupo-op-name {
                        padding: 5px 10px;
                        margin-bottom: 5px;

                        span {
                            font-size: 20px;
                        }
                    }

                    .min-observations-message {
                        font-size: 15px;
                    }
                    .obs-item-container {
                        grid-template-columns: calc(50% - 5px) calc(50% - 5px);
                        grid-column-gap: 10px;

                        .item-obs {
                            margin-top: 10px;

                            label {
                                padding-left: 5px;

                                span {
                                    font-size: 15px;
                                }
                            }
                        }
                    }

                    .obs-item-container {
                        position: relative;
                        display: grid;
                        grid-template-columns: calc(50% - 5px) calc(50% - 5px);
                        grid-column-gap: 10px;

                        .item-obs {
                            margin-top: 10px;
                            border-radius: 3px;
                            box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
                            padding: 7px 5px;
                            .container-input {
                                display: none;
                            }

                            &.selected {
                                box-shadow: 0 0 5px 0 rgba(19, 165, 0, 0.3);
                            }
                        }
                    }

                    .div-input-android {
                        height: 100px;
                        font-size: 22px;
                        padding: 5px 10px;
                    }
                }

                #keyboard-filler {
                    height: 150px;
                }
            }
        }

        .prod-item-footer {
            height: 60px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            button {
                width: 90%;
            }
        }
    }

    #android-keyboard {
        .small-screen-keyboard;
        bottom: 30px;
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    //@tablet

    .obs-modal-container {
        height: 1150px;
        grid-template-rows: 1fr 130px;
        margin: auto 50px;

        .modal-form-container {
            .title-box {
                height: 100px;
                margin-bottom: 15px;

                h2 {
                    font-size: 35px;
                }
            }
            .name-container {
                margin: 20px 0;
                font-size: 25px;
            }
            .image-container {
                padding: 10px;

                img {
                    height: 250px;
                }
            }

            .observations-container {
                .observations-group-container {
                    .grupo-op-name {
                        span {
                            font-size: 30px;
                        }
                    }
                    .min-observations-message {
                        font-size: 19px;
                    }
                }
                #keyboard-filler {
                    height: 150px;
                }
            }
        }

        .prod-item-footer {
            height: 130px;
        }
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
        max-width: 760px;
        font-size: 20px;
    }
}

@media (orientation: landscape) {
    .obs-modal-container {
        height: auto;
        grid-template-rows: 1fr 100px;
        margin: 30px 50px;

        .modal-form-container {
            .title-box {
                height: 70px;
                margin-bottom: 0;

                h2 {
                    font-size: 28px;
                }
            }

            .product-info-wrapper {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 20px;
                padding: 10px 20px;
                height: auto;
                min-height: 180px;
                max-height: 220px;
            }

            .image-container {
                padding: 10px;
                flex: 0 0 auto;
                height: 100%;

                img {
                    height: 100%;
                    object-fit: scale-down;
                }
            }

            .name-container {
                margin: 0;
                padding: 0;
                flex: 1;
                text-align: center;
                font-size: 1.6rem;
            }

            .observations-container {
                padding: 0 30px 0 30px;

                .observations-group-container {
                    margin-bottom: 10px;

                    .grupo-op-name {
                        margin-bottom: 0;
                        padding: 5px 15px;

                        span {
                            font-size: 1.7rem;
                        }
                    }

                    .min-observations-message {
                        font-size: 19px;
                    }
                    .obs-item-container {

                        .item-obs {
                            padding: 12px 10px;
                        }
                    }

                    .typed-obs-text {
                        font-size: 32px;
                        font-family: @default-font;
                        width: 100%;
                        resize: none;
                        border: 2px solid @primary-color;
                    }
                }
            }
        }

        .prod-item-footer {
            height: 100px;
            button {
                width: 80%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ObservationsModal.vue